module.exports = __webpack_public_path__ + "static/media/404-toon.24f93818.png";